// import React from 'react'
// import { Link } from 'react-router-dom'
// import logoProductionCapabilities from "../../imagens/logos/logoProductionCapabilities.png"
// import imgWireCapabilities from "../../imagens/wires/wireCapabilities.png"
// import imgTestCapabilities from "../../imagens/testCapabilities.png"
// import imgMachineCapabilities from "../../imagens/machineCapabilities.png"
// import imgPlasticParts from "../../imagens/pecasplasticas/plasticCapabilities.png"
// import imgWeldCapabilities from "../../imagens/welds/imgWeldCapabilties.png"
// import imgWireProduction from "../../imagens/imgWireProduction.png"
// import imgMetrology from "../../imagens/metrology/imgMetrology.png"
// import imgStamping from "../../imagens/stamping/imgStampingCapabilities.png"

// import "./cardsProductionCapabilites.css"

// function CardsProductionCapabilities() {
//   return (
//     <div>
//       <div className="text-start ms-2">
//         <img className="img-fluid img-custom-size" src={logoProductionCapabilities} alt="Capabilities Logo" />
//       </div>
//       <div className="container-fluid pt-5">
//         <div className="row justify-content-around">
//           <div className="col-md-3 col-sm-3 mb-4 hover-custom custom-width mx-2">
//             <Link className="text-decoration-none" to="/Capabilities/Production/WireProduction">
//               <img src={imgWireProduction} className="img-fluid" alt="Test Capabilities" />
//               <h2 className="textCapabilities text-wrap text-center mt-2 fs-md-5">Wires Production</h2>
//             </Link>
//           </div>
//           <div className="col-md-3 col-sm-3 mb-4 hover-custom custom-width mx-2">
//             <Link className="text-decoration-none" to="/Capabilities/Production/Wires">
//               <img src={imgWireCapabilities} className="img-fluid" alt="Wire Capabilities" />
//               <h2 className="textCapabilities text-wrap text-center mt-2 s-md-5">Wire Harnesses and assemblies</h2>
//             </Link>
//           </div>
//           <div className="col-md-3 col-sm-3 mb-4 hover-custom custom-width mx-2">
//             <Link className="text-decoration-none" to="/Capabilities/Production/Plastics">
//               <img src={imgPlasticParts} className="img-fluid" alt="Plastic Capabilities" />
//               <h2 className="textCapabilities text-wrap text-center mt-2 fs-md-5">Plastic parts injection, overmoldings and assemblies</h2>
//             </Link>
//           </div>
//           <div className="col-md-3 col-sm-3 mb-4 hover-custom custom-width">
//             <Link className="text-decoration-none" to="/Capabilities/Production/Stamping">
//               <img src={imgStamping} className="img-fluid" alt="Stamping Capabilities" />
//               <h2 className="textCapabilities text-wrap text-center mt-2 fs-md-5">Stamping</h2>
//             </Link>
//           </div>
//           <div className="col-md-3 col-sm-3 mb-4 hover-custom custom-width mx-2">
//             <Link className="text-decoration-none" to="/Capabilities/Production/Weldings">
//               <img src={imgWeldCapabilities} className="img-fluid" alt="Welding Capabilities" />
//               <h2 className="textCapabilities text-wrap text-center mt-2 fs-md-5">Weldings and solderings</h2>
//             </Link>
//           </div>
//           <div className="col-md-3 col-sm-3 mb-4 hover-custom custom-width mx-2">
//             <Link className="text-decoration-none" to="/Capabilities/Production/Equipments">
//               <img src={imgMachineCapabilities} className="img-fluid" alt="Machine Capabilities" />
//               <h2 className="textCapabilities text-wrap text-center mt-2  s-md-5">Equipments</h2>
//             </Link>
//           </div>
//           <div className="col-md-3 col-sm-3 mb-4 hover-custom custom-width mx-2">
//             <Link className="text-decoration-none" to="/Capabilities/Production/WireChecks">
//               <img src={imgTestCapabilities} className="img-fluid" alt="Test Capabilities" />
//               <h2 className="textCapabilities text-wrap text-center mt-2 fs-md-5">Quality controls and checks</h2>
//             </Link>
//           </div>
//           <div className="col-md-3 col-sm-3 mb-4 hover-custom custom-width">
//             <Link className="text-decoration-none" to="/Capabilities/Production/MetrologyCapabilities">
//               <img src={imgMetrology} className="img-fluid" alt="Metrology Capabilities" />
//               <h2 className="textCapabilities text-wrap text-center mt-2 fs-md-5">Lab & Metrology</h2>
//             </Link>
//           </div>

//         </div>
//       </div>
//       <div className="text-center my-4">
//         <Link to="/Capabilities">
//           <button className="buttonCapabilities">Back to Capabilities</button>
//         </Link>
//       </div>
//     </div>
//   );
// }
// export default CardsProductionCapabilities


import React from 'react';
import { Link } from 'react-router-dom';
import logoProductionCapabilities from "../../imagens/logos/logoProductionCapabilities.png";
import imgWireCapabilities from "../../imagens/wires/wireCapabilities.png";
import imgTestCapabilities from "../../imagens/testCapabilities.png";
import imgMachineCapabilities from "../../imagens/machineCapabilities.png";
import imgPlasticParts from "../../imagens/pecasplasticas/plasticCapabilities.png";
import imgWeldCapabilities from "../../imagens/welds/imgWeldCapabilties.png";
import imgWireProduction from "../../imagens/imgWireProduction.png";
import imgMetrology from "../../imagens/metrology/imgMetrology.png";
import imgStamping from "../../imagens/stamping/imgStampingCapabilities.png";

import "./cardsProductionCapabilites.css";

const cardsData = [
  { img: imgWireProduction, alt: "Test Capabilities", title: "Wires Production", link: "/Capabilities/Production/WireProduction" },
  { img: imgWireCapabilities, alt: "Wire Capabilities", title: "Wire Harnesses and assemblies", link: "/Capabilities/Production/Wires" },
  { img: imgPlasticParts, alt: "Plastic Capabilities", title: "Plastic parts injection, overmoldings and assemblies", link: "/Capabilities/Production/Plastics" },
  { img: imgStamping, alt: "Stamping Capabilities", title: "Stamping", link: "/Capabilities/Production/Stamping" },
  { img: imgWeldCapabilities, alt: "Welding Capabilities", title: "Weldings and solderings", link: "/Capabilities/Production/Weldings" },
  { img: imgMachineCapabilities, alt: "Machine Capabilities", title: "Equipments", link: "/Capabilities/Production/Equipments" },
  { img: imgTestCapabilities, alt: "Test Capabilities", title: "Quality controls and checks", link: "/Capabilities/Production/WireChecks" },
  { img: imgMetrology, alt: "Metrology Capabilities", title: "Lab & Metrology", link: "/Capabilities/Production/MetrologyCapabilities" }
];

function CardsProductionCapabilities() {
  return (
    <div>
      <div className="text-start ms-2">
        <img className="img-fluid img-custom-size" src={logoProductionCapabilities} alt="Capabilities Logo" />
      </div>
      <div className="container pt-3">
        <div className="customrow w-100 justify-content-between">
          {cardsData.map((card, index) => (
            <div key={index} className="col-md-3 col-sm-4 mb-4 hover-custom custom-width mx-4">
              <Link className="text-decoration-none" to={card.link}>
                <img src={card.img} className="img-fluid" alt={card.alt} />
                <h2 className="textCapabilities text-wrap text-center mt-2 fs-md-5">{card.title}</h2>
              </Link>
            </div>
          ))}
        </div>
      </div>
      <div className="text-center my-4">
        <Link to="/Capabilities">
          <button className="buttonCapabilities">Back to Capabilities</button>
        </Link>
      </div>
    </div>
  );
}

export default CardsProductionCapabilities;